import React from "react";

const Footer = () => {
  return (
    <footer>
      <div tabIndex="0">
        <p className="signature">Technigo Bootcamp Fall 2020</p>
        <p className="signature">&#169; 2020 Sandrine Elander</p>
      </div>
      <p tabIndex="0" className="attribution">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://icons8.com/icons/set/red-heart"
        >
          Red Heart icon
        </a>
        by
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://icons8.com"
        >
          Icons8
        </a>
      </p>
    </footer>
  );
};

export default Footer;